export default __webpack_public_path__ + "static/media/505EEC3C-848A-48A7-A6D7-6FF523F6A4AD_1_105_c.d0b11af3.jpeg";